module.exports = __webpack_public_path__ + "18d5994e20fd9b0b0ad61121b0ec6309.png";